// TODO: We should polish this function and move it to core.
const debounce = function (func, wait) {
    let timeout = null

    return function () {
        if (timeout) { clearTimeout(timeout) }
        timeout = setTimeout(func, wait)
    }
}

export default {
    install (Vue) {
        const eventBus = new Vue()

        const BREAKPOINTS = {
            SMALL: 0,
            MEDIUM: 481,
            LARGE: 641,
            XLARGE: 961
        }

        const sortedBreakpoints = Object.keys(BREAKPOINTS).map(key => BREAKPOINTS[key]).sort((lhs, rhs) => {
            return lhs - rhs
        })

        const EVENTS = {
            CHANGE_BREAKPOINT: 'change-breakpoint',
            RESIZE: 'resize'
        }

        const getBreakpoint = (windowWidth) => {
            return sortedBreakpoints.find((breakpoint, index) => {
                return index === sortedBreakpoints.length - 1 || (breakpoint <= windowWidth && windowWidth < sortedBreakpoints[index + 1])
            })
        }

        let breakpoint = getBreakpoint(window.innerWidth)

        window.addEventListener('resize', debounce(event => {
            const newBreakpoint = getBreakpoint(window.innerWidth)

            if (newBreakpoint !== breakpoint) {
                breakpoint = newBreakpoint
                eventBus.$emit(EVENTS.CHANGE_BREAKPOINT, breakpoint)
            }

            eventBus.$emit(EVENTS.RESIZE, event)
        }, 200))

        Vue.prototype.$window = {
            BREAKPOINTS,
            EVENTS,

            getBreakpoint () {
                return getBreakpoint(window.innerWidth)
            },

            getFontFamily () {
                return window.getComputedStyle(document.body).getPropertyValue('font-family')
            },

            on (eventName, eventHandler) {
                eventBus.$on(eventName, eventHandler)
            },

            off (eventName, eventHandler) {
                eventBus.$off(eventName, eventHandler)
            }
        }
    }
}
